/* eslint-disable @typescript-eslint/no-magic-numbers */

export enum FontFamily {
  Bold = 'roboto',
  Light = 'roboto',
  Medium = 'roboto',
  Regular = 'roboto',
  Thin = 'roboto',
}

export enum FontSize {
  H1 = '30px',
  H2 = '24px',
  H3 = '22px',
  H4 = '18px',
  H5 = '17px',
  H6 = '16px',
  XLarge = '45px',
  Large = '20px',
  Medium = '17px',
  Regular = '16px',
  Small = '14px',
  Tiny = '13px',
  Mini = '11px',
}

export enum FontWeight {
  Thin = '100',
  UltraLight = '200',
  Light = '300',
  Regular = '400',
  Medium = '500',
  Semibold = '600',
  Bold = '700',
  Heavy = '800',
  Black = '900',
}
